module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transparent_control_panel",
    style: (_vm.position),
    on: {
      "mouseover": _vm.mouseEnter,
      "mouseout": _vm.mouseOut,
      "mouseup": _vm.mouseUp,
      "mousedown": _vm.mouseDown,
      "mousemove": _vm.mouseMove
    }
  }, [_c('div', {
    staticClass: "expanded-Area"
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.cancel,
      "width": 12,
      "height": 12
    }
  })], 1), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: {
      'transparent_control_panel__non_expanded_area': !_vm.showExpand,
      'transparent_control_panel__no-display': _vm.showExpand
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42b9a62f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/controlPanel/TransparentControlPanel.vue
// module id = 1872
// module chunks = 0